__turbopack_context__.v({
  "logo": "_hiE0G_logo",
  "small": "_hiE0G_small",
  "small-logo": "_hiE0G_small-logo",
  "wrapper": "_hiE0G_wrapper",
});
